var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPassword2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2074",
    "data-name": "Rectangle 2074",
    width: 161.13,
    height: 172.924,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2601",
    "data-name": "Groupe 2601",
    transform: "translate(-833 -241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2382",
    "data-name": "Groupe 2382",
    transform: "translate(1 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2600",
    "data-name": "Groupe 2600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2599",
    "data-name": "Groupe 2599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2999",
    "data-name": "Trac\\xE9 2999",
    d: "M128,0A128,128,0,1,1,0,128,128.019,128.019,0,0,1,128,0Z",
    transform: "translate(832 275)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2384",
    "data-name": "Groupe 2384",
    transform: "translate(893 316.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2384-2",
    "data-name": "Groupe 2384",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2927",
    "data-name": "Trac\\xE9 2927",
    d: "M12.656,62.819H25.909a3.266,3.266,0,0,0,3.27-3.27V45.981a26.26,26.26,0,0,1,52.52,0V59.549a3.256,3.256,0,0,0,3.27,3.27H98.2a3.253,3.253,0,0,0,3.206-3.27V45.981a44.609,44.609,0,0,0-1.09-9.92A45.975,45.975,0,0,0,9.45,45.981V59.549a3.263,3.263,0,0,0,3.206,3.27",
    transform: "translate(5.477 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2928",
    "data-name": "Trac\\xE9 2928",
    d: "M108.689,43.937H13.142A13.128,13.128,0,0,0,0,57.063v58.822a13.142,13.142,0,0,0,13.142,13.142H88.55a41.143,41.143,0,0,1,33.281-57.306V57.063a13.139,13.139,0,0,0-13.142-13.126m-40.1,44.922v16.1a7.669,7.669,0,1,1-15.337,0v-16.1a15.9,15.9,0,0,1-.569-27.547h.016a15.9,15.9,0,0,1,16.443,0h.016a15.9,15.9,0,0,1-.569,27.547",
    transform: "translate(0 25.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2929",
    "data-name": "Trac\\xE9 2929",
    d: "M127.574,100.206a34.837,34.837,0,1,1-39.3-34.545,34.407,34.407,0,0,1,4.454-.284,34.879,34.879,0,0,1,34.845,34.829",
    transform: "translate(33.556 37.889)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2930",
    "data-name": "Trac\\xE9 2930",
    d: "M82.83,109.582a3.144,3.144,0,0,1-2.1-.8L65.858,95.487a3.159,3.159,0,0,1,4.211-4.71L82.64,102.014l22.535-23.982a3.16,3.16,0,1,1,4.6,4.33L85.133,108.586a3.151,3.151,0,0,1-2.3,1",
    transform: "translate(37.557 44.647)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword2);
export default __webpack_public_path__ + "static/media/resetPassword2.20401a0151fb933dc92ba68a37e3a35e.svg";
export { ForwardRef as ReactComponent };